import React, { Component, Fragment } from 'react';
import _set from 'lodash/set';
import _get from 'lodash/get';

import Dialog from 'material-ui/Dialog';
import FlatButton from 'material-ui/FlatButton';
import TextField from 'material-ui/TextField';
import AutoComplete from 'material-ui/AutoComplete';
import SelectField from 'material-ui/SelectField';
import MenuItem from 'material-ui/MenuItem';

import api from 'services';
import { getNormalErrors, showNotification } from 'helpers';

export default class RegionModalAdd extends Component {

  state = {
    data: {},
    areaType: 'port', // port, country
    countries: [],
    areas: [],
    errors: {},
    error: '',
  }

  fetchAreas = async (value = '') => {
    if (value.length < 2) {
      return false;
    }

    let result = await api.findPortAdmin({name: value})

    if (result.status === 200) {
      this.setState({
        areas: _get(result, 'data.data', [])
          .map(ar => ({title: `${ar.name}${ar.unLoCode ? ' (' + ar.unLoCode + ')' : ''}`,
        value: ar._id}))
      })
    }
  }

  toggleType(value = '') {
    let { countries = [] } = this.state;

    if (!countries.length && value === 'country') {
      api.getCountries()
        .then(countries => this.setState({countries: countries.data || []}))
    }

    this.setState({areaType: value});
  }

  handleChange = (key, value = '') => {
    if (key !== '_id') {
      let dots = 0;
      value = value
        .replace(/[^\d|\.|-]/, '')
        .replace(/\./g, function() { return dots++ > 0 ? '' : '.'; })
        .replace(/\-/g, function(match, str) { return str === 0 ? '-' : '' });
    }

    let data = this.state.data;
    _set(data, key, value);

    this.setState({
      data,
      errors: {
        ...this.state.errors,
        [key]: value && (key === '_id' ? true : !isNaN(parseFloat(value))) ? '' : 'required'
      },
      error: ''
    })
  }

  validate = () => {
    let { data } = this.state;
    let errors = {};

    if (!data._id) {
      errors._id = 'required';
    }

    if (!Object.keys(errors).length) {
      return true
    }

    this.setState({errors});
    return false;
  }

  save = async () => {
    let { data, areaType } = this.state;
    let type = areaType === 'port' ? 'region' : 'country';

    if (!this.validate()) {
      return showNotification('There is an error. Check out inputs', 'error');
    }

    let result = await api.disbursement.create({
      type: areaType,
      [type]: data._id,
    });

    if (result.status === 200) {
      showNotification('Region has been created')
      await this.props.getRegions();
      return this.props.toggleDialog();
    }

    this.setState({...getNormalErrors(result)})
    showNotification(this.state.error, 'error')
  }

  render() {
    let { toggleDialog, isDialogOpened } = this.props;
    let { data, error, areas, areaType, countries = [] } = this.state;

    return (
      <Dialog
        title='Add new region'
        actions={[
          <FlatButton
            label='Ok'
            primary
            onClick={this.save}
          />,
          <FlatButton
            label='Cancel'
            primary
            onClick={toggleDialog}
          />
        ]}
        open={isDialogOpened}
        autoScrollBodyContent
        modal
      >
        <h4 className='m-b-0'>{'Name'}</h4>
        <SelectField
          value={areaType}
          onChange={(e, some, value) => this.toggleType(value)}
          hintText='Type'
          floatingLabelText='Type'
          fullWidth
        >
          <MenuItem key='port' value='port' primaryText='Port' />
          <MenuItem key='country' value='country' primaryText='Country' />
        </SelectField>
        {
          areaType === 'port' ?
            <AutoComplete
              hintText="Name"
              floatingLabelText="Name"
              dataSource={areas}
              dataSourceConfig={{text: 'title', value: 'value'}}
              onUpdateInput={(value) => {this.handleChange('_id', ''); this.fetchAreas(value)}}
              onNewRequest={(selected) => this.handleChange('_id', selected.value)}
              fullWidth={true}
              filter={AutoComplete.noFilter}
              menuStyle={{ maxHeight: '300px', overflowY: 'auto' }}
              errorText={data._id ? '' : 'required'}
            />
          :
            <SelectField
              value={data._id}
              onChange={(e, some, value) => this.handleChange('_id', value)}
              hintText='Name'
              floatingLabelText='Country'
              fullWidth
              errorText={data._id ? '' : 'required'}
            >
              {
                countries.map((country, index) => {
                  return (
                    <MenuItem
                      key={index}
                      value={country._id}
                      primaryText={country.name}
                    />
                  );
                })
              }
            </SelectField>
        }
        {
          error &&
            <div className='error'>{error}</div>
        }
      </Dialog>
    )
  }
}



// WEBPACK FOOTER //
// ./app/components/Disbursement/RegionModalAdd.js